/* unplugin-vue-components disabled */import { render } from "./AddPlatform.vue?vue&type=template&id=534abaaa&ts=true"
import script from "./AddPlatform.vue?vue&type=script&lang=ts"
export * from "./AddPlatform.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__